exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.leo-knowledge-tip-popper {\r\n  max-width: 440px !important;\n}\n.leo-knowledge-tip-popper .leo-tip-rich {\r\n  line-height: 1.55;\r\n  word-break: break-word;\r\n  white-space: pre-wrap;\n}\r\n", "", {"version":3,"sources":["C:/Users/steve/Desktop/Android/Xrross-SOC-Frontend/src/components/LeoKnowledge/LeoFormLabelTip.vue"],"names":[],"mappings":";AAkCA;EACE,4BAA4B;CAC7B;AACD;EACE,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;CACvB","file":"LeoFormLabelTip.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\r\n.leo-knowledge-tip-popper {\r\n  max-width: 440px !important;\r\n}\r\n.leo-knowledge-tip-popper .leo-tip-rich {\r\n  line-height: 1.55;\r\n  word-break: break-word;\r\n  white-space: pre-wrap;\r\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1843012a","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/LeoKnowledge/LeoFormLabelTip.vue
// module id = lhxH
// module chunks = 348